import config from "config";

import { getIsCypressAut } from "./helpers/isCypressAut";

const {
  adsMsalConfig,
  newPasswordMsalConfig,
  emailMsalConfig,
  emailSignUpMsalConfig,
} = config;
const port = window.location.port ? `:${window.location.port}` : "";
const rootRedirectUri = `${window.location.protocol}//${window.location.hostname}${port}/`;
const isCypressRuntime = getIsCypressAut();
/**
 * Silent / iframe flows default to auth-redirect.html (separate from interactive).
 * Cypress hits acquireTokenSilent from axios before the UI is ready; B2C often
 * registers only the app root for localhost, so auth-redirect.html throws
 * redirect_uri_mismatch and can bounce the app to /holding or /login.
 */
export const SILENT_REDIRECT_URI = isCypressRuntime
  ? rootRedirectUri
  : `${window.location.protocol}//${window.location.hostname}${port}/auth-redirect.html`;
export const msalcfg = {
  auth: {
    clientId: adsMsalConfig.clientID,
    authority: adsMsalConfig.authority,
    //knownAuthorities: ["ajwnextb2c.b2clogin.com"],
    knownAuthorities: adsMsalConfig.knownAuthorities,
    redirectUri: rootRedirectUri,
    // Ensure logout always returns to the login route to avoid maintenance flicker
    postLogoutRedirectUri: `${window.location.protocol}//${window.location.hostname}${port}/#/login`,
    allowRedirectInIframe: true,
    // With HashRouter, navigating back to the login-request URL (#/login) after
    // the IdP posts to / strips the auth fragment before handleRedirectPromise
    // finishes, which breaks email/redirect login. Stay on the registered redirect URI.
    navigateToLoginRequestUrl: false,
  },

  cache: {
    //i added cache location? maybe don't need?
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false, //fix for the authentication loop issues on IE and Edge
  },

  system: {
    allowNativeBroker: false, //prevent confusion as to whether we're using a native broker- no native prompts or flows that oculd interfere
    iframeHashTimeout: 10000, //how long MSAL will wiat for auth responses in hidden iframes- increasing can help if auth provider is ever slow to respond and reduces chance of timeout errors
    loadFrameTimeout: 10000, //how long MSAL will wait for the auth response iframe to load- increasing can help if auth provider is ever slow to respond and reduces chance of timeout errors
    navigateFrameWait: 50, // Added: brief wait to reduce rare hash parsing races in iframes
    asyncPopups: false, //Forces MSAL to use synchronous popups instead of async ones- This can help avoid issues where popup windows are blocked or not handled correctly by the browser (although we're trying not to use popups!)
  },
};

//config'd to ensure it continues with auth even if SSO fails
export const loginRequest = {
  scopes: ["openid", ...adsMsalConfig.b2cScopes],
  prompt: "login", //forces login prompt every time rather than silently or using a cached session, keeps user actively logging in, especially after a failed SSO probe. OInly triggered by loginRedirect or popup, so won't affect silent token refresh
  extraQueryParameters: {
    login_hint: "", //clears any login hints that might have been set previously- This ensures that the login page does not pre-fill with a previous username, which can help avoid issues where MSAL tries to “help” but ends up causing a loop or a failed login.
    domain_hint: "", //clears any domain hints that might have been set previously- This ensures that the login page does not pre-fill with a previous domain, which can help avoid issues where MSAL tries to “help” but ends up causing a loop or a failed login.
  },
};

export const emailLoginRequest = {
  scopes: ["openid", ...adsMsalConfig.b2cScopes],
  authority: emailMsalConfig.authority,
  prompt: "login",
};

export const newPwdRequest = {
  scopes: ["openid", ...adsMsalConfig.b2cScopes],
  authority: newPasswordMsalConfig.authority,
};

export const signUpRequest = {
  scopes: ["openid", ...adsMsalConfig.b2cScopes],

  authority: emailSignUpMsalConfig.authority,
};

// Silent SSO requests (no prompt) for seamless cross-app SSO
export const ssoRequest = {
  scopes: ["openid", ...adsMsalConfig.b2cScopes],
  prompt: "none",
  redirectUri: SILENT_REDIRECT_URI,
};

export const emailSsoRequest = {
  scopes: ["openid", ...adsMsalConfig.b2cScopes],
  authority: emailMsalConfig.authority,
  prompt: "none",
  redirectUri: SILENT_REDIRECT_URI,
};

export const silentLoginRequest = localStorage.getItem("ads.loginHint")
  ? {
      scopes: ["openid", ...adsMsalConfig.b2cScopes],
      loginHint: localStorage.getItem("ads.loginHint"),
      redirectUri: SILENT_REDIRECT_URI,
    }
  : {};

export const silentEmailLoginRequest = localStorage.getItem(
  "ads.loginHint",
)
  ? {
      scopes: ["openid", ...adsMsalConfig.b2cScopes],
      authority: emailMsalConfig.authority,
      loginHint: localStorage.getItem("ads.loginHint"),
      redirectUri: SILENT_REDIRECT_URI,
    }
  : {};
